import React from 'react';
import TopBar from '../../dashboard/TopBar';

const DatasetLayout = ({ title, description, showTopbar, children }) => {
  console.log('DatasetLayout props:', { title, description, showTopbar, children });
  return (
    <div className="dashboard-root">
      <div className="main-area">

        {showTopbar && <TopBar title={title} />}
        <div style={{ padding: '1rem' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DatasetLayout;